import T from '../../../../common/components/T';
import Product from '../../../../widgets/product/Product/Product';
import css from './StoreProductsGrid.module.scss';

export default function StoreProductsGrid({ products, title, lightTitle }) {
    if (!products?.length) return null;
    return (
        <div className={css.wrapper}>
            <h1 className={css.lightTitle}>{lightTitle || 'Global Trend'}</h1>
            <div className={css.content}>
                {/* <div className={css.gridHeader}>
                    <Filter />
                </div> */}
                <p className={css.gridTitle}>
                    {title || <T textName='gt-products' defaultStr='Продукция Global Trend' page='/store' />}
                </p>
                <div className={css.gridTable}>
                    {products?.map((product) => (
                        <Product
                            key={product.id}
                            product={product}
                            stylesMix={css}
                            isAllowAddProduct={true}
                            setAllowAddProduct={() => {}}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
